export default "__VITE_ASSET__DMuDEH02__"